import { OrderbookItem } from '@/types/otc'
import { formatCompactNumber } from '@/utils'

export interface DiscountItem extends OrderbookItem {
  discount?: number
  originalPrice?: number
  marketPrice?: number
  tag?: 'hot' | 'trending' | 'most_profitable'
  priceHistory?: Array<{ date: string; value: number }>
}

export interface TopDiscountsTodayBaseProps {
  items: DiscountItem[]
  loading?: boolean
  onItemClick?: (item: DiscountItem) => void
  onBuyClick?: (item: DiscountItem) => void
}

export const calculateDiscount = (item: DiscountItem): number => {
  // Discount is already in positive format from API transformation
  let discount = 0
  if (item.discount !== undefined) {
    discount = Math.abs(item.discount)
  } else if (item.originalPrice && item.offered_amount) {
    discount = ((item.originalPrice - item.offered_amount) / item.originalPrice) * 100
  }
  // Round to 1 decimal place to avoid floating point precision issues
  return Math.round(discount * 10) / 10
}

export const formatDiscount = (discount: number): string => {
  // If it's a whole number, show without decimal
  if (discount % 1 === 0) {
    return discount.toFixed(0)
  }
  // Otherwise show 1 decimal place
  return discount.toFixed(1)
}

export const formatPrice = (item: DiscountItem): string => {
  if (item.marketPrice) {
    return `$${formatCompactNumber(item.offered_amount)} (market $${formatCompactNumber(item.marketPrice)})`
  }
  if (item.originalPrice) {
    return `$${formatCompactNumber(item.offered_amount)} instead of $${formatCompactNumber(item.originalPrice)}`
  }
  return `$${formatCompactNumber(item.offered_amount)}`
}

